import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';
import { ITrackResponse } from 'services/tracks/types';

export const updateMusicProdoctDigitalAlbumsFromTrackResponse = (
  trackResponse: ITrackResponse,
  form: IMusicProductDigitalForm,
): IMusicProductDigitalForm => {
  const newTrack = {
    name: trackResponse.mainTitle.title,
    id: trackResponse.id,
    version: trackResponse.mainTitle.version ?? '',
    trackStatus: trackResponse.trackStatus,
    isrc: trackResponse.isrc ?? '',
    wavLink: trackResponse.wavLink ?? '',
    mp3Link: trackResponse.mp3Link ?? '',
    flacLink: trackResponse.flacLink ?? '',
    mp3PreviewLink: trackResponse.mp3PreviewLink ?? '',
  };

  if (form.tracks.length === 0) {
    return {
      ...form,
      tracks: [
        {
          tracks: [newTrack],
        },
      ],
    };
  }

  return {
    ...form,
    tracks: form.tracks.map((album) => {
      let trackExists = album.tracks.some((t) => t.id === trackResponse.id);

      if (trackExists) {
        return {
          ...album,
          tracks: album.tracks.map((t) => (t.id === trackResponse.id ? newTrack : t)),
        };
      }

      return {
        ...album,
        tracks: [...album.tracks, newTrack],
      };
    }),
  };
};
